type AbortableThunk = (...args: any[]) => any;

const abortControllers = new Map<string, any>();

export function createAbortableThunk<T extends AbortableThunk>(
  thunk: T,
  key: string = thunk.name // default key per thunk
) {
  return (...args: Parameters<T>) => {
    return (dispatch: any) => {
      // Abort previous request for this key
      const previous = abortControllers.get(key);
      if (previous) {
        previous.abort();
      }

      // Dispatch new thunk
      const promise = dispatch(thunk(...args));

      // Store promise (RTK thunk promise has abort())
      abortControllers.set(key, promise);

      return promise;
    };
  };
}
